import {
  CAT_RUNNING_STAGE_DISTANCE_M,
  CAT_RUNNING_STAGE_KEYS,
  CAT_RUNNING_STAGE_LOOPS,
} from '../constants'

export const pickRandomStartStageKey = () => {
  const index = Math.floor(Math.random() * CAT_RUNNING_STAGE_KEYS.length)
  return CAT_RUNNING_STAGE_KEYS[index]
}

/** 구버전 리플레이(startStageKey 미저장) 복원용 */
export const pickStartStageKeyFromSeed = (runSeed) => {
  const text = String(runSeed ?? '0')
  let hash = 2166136261
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i)
    hash = Math.imul(hash, 16777619)
  }
  const index = Math.abs(hash) % CAT_RUNNING_STAGE_KEYS.length
  return CAT_RUNNING_STAGE_KEYS[index]
}

export const resolveInitialStartStageKey = (options = {}, runSeed) => {
  const explicit = options.startStageKey ?? options.replayData?.startStageKey
  if (explicit && CAT_RUNNING_STAGE_KEYS.includes(explicit)) {
    return explicit
  }

  const isReplay = Boolean(options.frameReplay || options.replayData)
  if (isReplay) {
    return pickStartStageKeyFromSeed(runSeed)
  }

  return pickRandomStartStageKey()
}

export const getStageLoop = (startStageKey) =>
  CAT_RUNNING_STAGE_LOOPS[startStageKey] ?? CAT_RUNNING_STAGE_LOOPS.forest

export const getStageKeyAtDistance = (startStageKey, distance) => {
  const loop = getStageLoop(startStageKey)
  const segment = Math.floor(Math.max(0, Number(distance) || 0) / CAT_RUNNING_STAGE_DISTANCE_M)
  return loop[segment % loop.length]
}
